import useSound from 'use-sound'
import deal from '../../../../lib/assets/audio/deal.mp3'
import clear from '../../../../lib/assets/audio/clear.mp3'
import raise from '../../../../lib/assets/audio/raise.mp3'
import bet from '../../../../lib/assets/audio/bet.mp3'
import undo from '../../../../lib/assets/audio/undo.mp3'
import fold from '../../../../lib/assets/audio/fold.mp3'
import check from '../../../../lib/assets/audio/check.mp3' 

export const useButtonSounds = (audio: any) => {
  const [playClearSFX] = useSound(clear, {
    volume: audio?.volume ? parseFloat(audio.volume) : 0,
  })
  const [playDealSFX] = useSound(deal, {
    volume: audio?.volume ? parseFloat(audio.volume) : 0,
  })
  const [playRaiseSFX] = useSound(raise, {
    volume: audio?.volume ? parseFloat(audio.volume) : 0,
  })
  const [playBetSFX] = useSound(bet, {
    volume: audio?.volume ? parseFloat(audio.volume) : 0,
  })
  const [playUndoSFX] = useSound(undo, {
    volume: audio?.volume ? parseFloat(audio.volume) : 0,
  })
  const [playFoldlSFX] = useSound(fold, {
    volume: audio?.volume ? parseFloat(audio.volume) : 0,
  })
  const [playCheckSFX] = useSound(check, {
    volume: audio?.volume ? parseFloat(audio.volume) : 0,
  })

  return {
    playDealSFX,
    playRaiseSFX,
    playBetSFX,
    playUndoSFX,
    playFoldlSFX,
    playCheckSFX,
    playClearSFX,
  }
}
